import { useEffect } from "react";
import useFirstMountState from "./useFirstMountState";

type EffectCallback = () => void | (() => void);

const useUpdateEffect = (effect: EffectCallback, deps: React.DependencyList): void => {
  const isFirstMount = useFirstMountState();

  useEffect(() => {
    if (!isFirstMount) {
      return effect();
    }
    return undefined;
  }, deps);
};

export default useUpdateEffect;
